import { createAction, props } from '@ngrx/store';
import { IRegulatoryRequest } from '../models/marketing-options.model';

export const loadAcceptRegulatory = createAction('[AcceptRegulatory] Load AcceptRegulatory', props<{ request: IRegulatoryRequest }>());

export const loadAcceptRegulatorySuccess = createAction('[AcceptRegulatory] Load AcceptRegulatory Success', props<{ response: any }>());

export const loadAcceptRegulatoryFailure = createAction(
  '[AcceptRegulatory] Load AcceptRegulatory Failure',
  props<{ error: Error | any }>()
);
